import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import useRazorpay from "react-razorpay";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import {
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
  Table,
  Button,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { getData } from "../../../utils/api";
library.add(fas);

const SubscribeOffCanvance = (props) => {
  const id = props.show;
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const navigate = useNavigate();

  const [error, setError] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors },
    setValue,
  } = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [razorid, setRazorId] = useState();
  const [Razorpay, openRazorpay] = useRazorpay();


  const handleRazorpay = async (storedValue) => {

    setIsLoading(true); // Show loading state

    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: Math.round(storedValue) * 100, // convert amount to paise
      currency: "INR",
      name: "Hiclousia",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        onSubmit("razor_pay", res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();

    rzpay.on("payment.failed", function (response) {
      console.log("Payment failed:", response);
      setIsLoading(false); // Hide loading on error
      alert("Payment failed. Please try again.");
      // setIsRazorPay(false);
    });
  };



  const onSubmit = async (type = "wallet", razor_id = "") => {
    try {
      const response = await postData(`/admin/subscription`, { plan_id: id, type, razor_id });
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.data });
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
          navigate("/vendor-subscriptions");
        }, 1000);
      } else {
        // await setShowModal({ code: response?.code, message: response?.errors });
        await setError(response?.errors);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [Plan, setPlan] = useState({});
  const [wallet, setWallet] = useState({});
  const getPlan = async () => {
    const plan = await getData(`/admin/subscription/plan/${id}`);
    setPlan(plan?.data);
  };

  const getUserAmount = async () => {
    const wallet = await getData(`/admin/wallet/my-wallet`);
    setWallet(wallet?.data);
  };

  useEffect(() => {
    getPlan();
    getUserAmount();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Purchase Plan
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className="text">
            <span>Current Wallet Amount:</span>
            <p className="text-green">
              {wallet?.amount != null
                ? new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(wallet.amount)
                : '₹0.00'}
            </p>
          </div>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <div className="text-center">
                    <Form.Label>Plan</Form.Label>
                  </div>

                  <div className="package-details-section-top-heading">
                    <div className="pending-table ">
                      <div className="d-flex  align-items-center">
                        <div className="text-center  ms-5">
                          <Form.Label>Plan</Form.Label>
                          <p> {Plan?.name} </p>
                        </div>

                        <div className="text-center  ms-5">
                          <Form.Label>Days</Form.Label>
                          <p> {Plan?.days} days</p>
                        </div>

                        <div className="text-center  ms-5">
                          <Form.Label>Price :</Form.Label>
                          <p> {Plan?.price} /-</p>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              {error && (
                <>
                  <span className="text-danger">{error}</span>
                  <div className="text-center  ms-5">
                    <Link to={"/my-wallet"}>
                      <Button>+ Add Money To Wallet</Button>
                    </Link>
                    <Button className="ms-2" onClick={() => { setError(""); handleRazorpay(Plan?.price) }}>Pay Now</Button>
                  </div>

                </>
              )}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"purchase"}
                    handleSubmit={handleSubmit(() => onSubmit("wallet"))}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default SubscribeOffCanvance;
